import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Member, TicketResponse } from '../models/tickets.models';

export const TicketSeverityChanged = createAction(
  '[Customer data: Edit Ticket]: Ticket Severity Changed',
  props<{ ticketSeverity: number }>(),
);

export const TicketStatusChanged = createAction(
  '[Customer data: Edit Ticket]: Ticket Status Changed',
  props<{ ticketStatus: number }>(),
);

export const TicketCountryChanged = createAction(
  '[Customer data: Edit Ticket]: Ticket Country Changed',
  props<{ country: number }>(),
);

export const TicketCategoryChanged = createAction(
  '[Customer data: Edit Ticket]: Ticket Category Changed',
  props<{ ticketCategory: number }>(),
);

export const TicketAssigneeChanged = createAction(
  '[Customer data: Edit Ticket]: Ticket Assignee Changed',
  props<{ ticketAssignee: number }>(),
);

export const TicketBodyChanged = createAction(
  '[Customer data: Edit Ticket]: Ticket Body Changed',
  props<{ body: string }>(),
);

export const TicketSubjectChanged = createAction(
  '[Customer data: Edit Ticket]: Ticket Subject Changed',
  props<{ subject: string }>(),
);

export const SearchFieldChanged = createAction(
  '[Customer data: Edit Ticket]: Search Field Changed',
  props<{ searchField: string }>(),
);

export const MatchMember = createAction('[Customer data: Edit Ticket]: Match Member');

export const MatchMemberSuccess = createAction(
  '[Customer data: Edit Ticket]: MatchMember Success',
  props<{ res: Member[] }>(),
);

export const MatchMemberFailed = createAction(
  '[Customer data: Edit Ticket]: MatchMember Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const RemoveMember = createAction('[Customer data: Edit Ticket]: Remove Member');

export const CreateTicket = createAction('[Customer data: Edit Ticket]: Create Ticket');

export const CreateTicketSuccess = createAction(
  '[Customer data: Edit Ticket]: Create Ticket Success',
  props<{ res: TicketResponse }>(),
);

export const CreateTicketFailed = createAction(
  '[Customer data: Edit Ticket]: Create Ticket Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const UpdateTicket = createAction('[Customer data: Edit Ticket]: Update Ticket');

export const UpdateTicketSuccess = createAction(
  '[Customer data: Edit Ticket]: Update Ticket Success',
  props<{ res: TicketResponse }>(),
);

export const UpdateTicketFailed = createAction(
  '[Customer data: Edit Ticket]: Update Ticket Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ToggleExecuteFlow = createAction(
  '[Customer data: Edit Ticket]: Toggle Execute Flow',
  props<{ isExecuteFlowChecked: boolean }>(),
);
